import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
@Component({
  selector: 'app-public-comment',
  templateUrl: './public-comment.component.html'
})
export class PublicCommentComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getexposuredocumentlabels();
  }
  exposurecontent;
  gasblinkurl;
  header;
  getexposuredocumentlabels() {
    this.graphQlService.getothersourceLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.exposurecontent = labels.filter(x => x.key == "docspublicComment").map(y => y.value);
        this.header = labels.filter(x => x.key == "docs_header").map(y => y.value);
        this.gasblinkurl = labels.filter(x => x.key == "docspubliclink").map(y => y.value);

        this.commonDataService.showLoader.next(false);
      }
    });
  }
  openLinkById(event) {
    event.target.href = this.gasblinkurl;

  }
  onRightClick(event) {
    event.target.href = this.gasblinkurl;
  }
}
